import { getUserId } from "../helpers"

export const getCompletedCourses = (): Promise<any> => {
  return new Promise<any[]>((resolve) => {
    const userID = getUserId()
    const url = process.env.REACT_APP_IBL_DM_URL + `/api/catalog/milestones/v2/completions/course/catalog/?user_id=${userID}`
    fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Token ' + localStorage.getItem('dm_token'),
      },
    }).then((response) => {
      if (!response.ok) {
        return response.text().then((text) => {
          throw new Error(`HTTP error ${response.status}: ${text}`);
        });
      }
      return response.json();
    })
      .then((data: any) => {
        resolve(data);
      }).catch((error) => {
        resolve(null)
        console.log('Error fetching completed courses-1:', error)
      })
  })

}